export default "__VITE_ASSET__Bp$lC4TQ__"